import { useDispatch, useSelector } from 'react-redux';
import type { RootState } from 'reducers';

import type { AppDispatch } from './index';

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();

export const useAppSelector: <T>(sel: (s: RootState) => T) => T = useSelector;
